import { render, staticRenderFns } from "./PreviewFileSideBar.vue?vue&type=template&id=3746a7c6"
import script from "./PreviewFileSideBar.vue?vue&type=script&lang=js"
export * from "./PreviewFileSideBar.vue?vue&type=script&lang=js"
import style0 from "./PreviewFileSideBar.vue?vue&type=style&index=0&id=3746a7c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports